<template>
  <div class="col text-center mt-3">
    <div class="product-card" v-if="merchantData.doesOnline || merchantData.doesOffline || merchantData.doesSocial">
      <a href="#">
        <div class="badge">   {{ merchantData.merchantDiscount }}</div>
  
        <div class="product-tumb"> 
          <img
            :src="merchantData.rectBannerUrl.formats.thumbnail.url"
            alt=""
            style="height:auto; width:100%;"
          />
        </div>
        {{ merchantData.merchantName }}
      </a>
    </div>
    <!-- <div class="product-card" v-else>
      <a :href="merchantData.siteUrl">
        <div class="badge">   {{ merchantData.merchantDiscount }}</div>
        <div class="product-tumb">
          <img
            :src="merchantData.rectBannerUrlformats.thumbnail.url"
            alt=""
            style="height:auto; width:100%;"
          />
        </div>
        {{ merchantData.merchantName }}
      </a>
    </div> -->
    <!-- <a :href="merchantData.siteUrl">
      <div style="">
        &nbsp;
     
        <div class="badge">50% Off</div>
        <img
          :src="merchantData.rectBannerUrl"
          style="height:auto; width:100%;"
          alt=""
        />
      </div>
   
      {{ merchantData.merchantName }}
    </a> -->
  </div>
</template>

<script>
import axios from "axios";
const Token =
  "44587566452cdd6463c3482e4b57853ff3292495d04632bc500b74009b8e943fd1ab9f35dd7cd7ce285993bf792ebe4134159527b0bd54e2e805fcd8e3cdd63b8eaf8be5cdb9100a8bae554f9f7b3ec128bbf7eccaac6eec9ecd1c58d78552f2b8d633685e5538ea60b8104a11c515a01f56177dee1fe0d83fe57fa979955646";

const bearToken = "Bearer " + Token;

export default {
  name: "MerRectDispWeb",
  props: {
    id: Number,
    mName: String,
    inStore: Boolean,
    online: Boolean,
  },
  data() {
    return {
      merchantData: [],
      // merchantData: {
      //   offlineLocations: Array,
      //   siteUrl: String,
      //   rectBannerUrl: URL,
      //   doesOffline: Boolean,
      // },
      loading: true,
    };
  },
  computed: {
    style() {
      return (
        'width:100%; height:auto; background-size: 100% auto; background-repeat: no-repeat;background-image: url("' +
        this.merchantData.rectBannerUrl.formats.thumbnail.url +
        '"; '
      );
    },
  },
  created() {
    // Simple POST request with a JSON body using axios
    // const article = { "MerchantId": 1 };
    // axios
    //   .post(
    //     "https://devapi.paykoko.com/backend/merchant",
    //      '{ "MerchantId": ' + this.id + "}"
    //   )
    //   .then((response) => {
    //     this.merchantData = response.data;
    //     this.loading = false;
    //   });

    let auth = {
      headers: {
        Authorization: bearToken,
      },
    };

    axios
      .get(
        "https://cms.paykoko.com/api/merchant-webs/" +
          this.id +
          "?populate=*",
        auth
      )
      .then((response) => {
        this.merchantData = response.data.data;
        console.log("__HOME_MERCHANT :", this.merchantData);
        this.loading = false;
      });
  },
};
</script>

<style scoped>
a {
  font-weight: bold;
  color: #2c3e50;
  text-decoration: none;
}

.product-card {
  position: relative;
  box-shadow: 0 2px 7px #dfdfdf;
  background-color: #f8f5f1;
}

.badge {
  font-family: "Lato";
  position: absolute;
  left: 0;
  top: 20px;
  text-transform: uppercase;
  font-size: 13px;
  font-weight: 700;
  background: #3f8952;
  color: #fff;
  /* border-radius: 1px; */
  padding: 3px 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  box-shadow: 0 3px 10px rgb(0 0 0 / 20%);
}

.badge2 {
  font-family: "Lato";
  position: absolute;
  right: 0;
  top: 20px;
  text-transform: uppercase;
  font-size: 13px;
  font-weight: 700;
  background: #3f8952;
  color: #fff;
  /* border-radius: 1px; */
  padding: 3px 10px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  box-shadow: 0 3px 10px rgb(0 0 0 / 20%);
}

.product-tumb {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f0;
}

.product-tumb img {
  max-width: 100%;
  max-height: 100%;
}
</style>
